import { useQuery } from '@tanstack/react-query';

import { QueryKey } from 'constants/query-key';
import { type Suggestion } from 'interfaces/copilot';
import { aiEngineClient } from 'services/connectivity/ml-gateway-api/ai-engine/client';
import { type ListSuggestionsResponse } from 'services/connectivity/ml-gateway-api/ai-engine/types';

function deserializeListSuggestions(payload: ListSuggestionsResponse): Suggestion[] {
  return payload.list_suggestions.map((item) => ({
    message: item.message,
    shortcut: item.suggestion_shortcut,
    description: item.description,
  }));
}

export async function listSuggestions(): Promise<Suggestion[]> {
  const { result, error } = await aiEngineClient.listSuggestions();

  if (error) {
    throw error;
  }

  return deserializeListSuggestions(result);
}

type UseListSuggestions = {
  data?: Suggestion[];
  isLoading: boolean;
  isError: boolean;
};

interface IProps {
  refetchOnMount?: boolean;
  enabled?: boolean;
}

export const useListSuggestions = ({ refetchOnMount = false, enabled = true }: IProps = {}): UseListSuggestions => {
  const { data, isLoading, isError } = useQuery([QueryKey.OneSuggestions], listSuggestions, {
    refetchOnMount,
    refetchOnWindowFocus: false,
    enabled,
    retry: 1,
    retryDelay: 1000,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
